import { combineReducers } from "redux";

import cohortsReducer from "./cohorts";
import dashboardReducer from "./dashboard";
import destinationsReducer from "./destinations";
import environmentsReducer from "./environments";
import eventDefsReducer from "./events";
import eventTesterReducer from "./eventTester";
import functionDefsReducer from "./functions";
import loginPageReducer from "./loginPage";
import objectSourcesReducer from "./objectSources";
import sourcesReducer from "./sources";
import usersReducer from "./users";

const freshpaintReducer = combineReducers({
  environments: environmentsReducer,
  destinations: destinationsReducer,
  sources: sourcesReducer,
  cohorts: cohortsReducer,
  eventDefs: eventDefsReducer,
  eventTester: eventTesterReducer,
  dashboard: dashboardReducer,
  objectSources: objectSourcesReducer,
  functionDefs: functionDefsReducer,
  users: usersReducer,
  loginPage: loginPageReducer,
});

export type FreshpaintState = ReturnType<typeof freshpaintReducer>;

export default freshpaintReducer;
